import React from 'react';
import { Box, Typography, Stack, Paper, useTheme, useMediaQuery } from '@mui/material';
import { getLogoBySubdomainOptimized } from '../utils/logoUtils';

const IndigentDashboard = () => {
    // theme and isMobile should have been global variable sets
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box
            sx={{
                minHeight: '100vh',
                backgroundColor: '#FEFBFF',
                display: 'flex',
                justifyContent: 'center',
                p: isMobile ? 0 : 2,
            }}
        >
            <Paper
                elevation={3}
                sx={{
                    width: '100%',
                    height: '100%',
                    minHeight: '80vh',
                    borderRadius: "12px",
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <Stack spacing={3} alignItems='center' textAlign='center' maxWidth={498}>
                    <Box
                        component='img'
                        src={getLogoBySubdomainOptimized()}
                        alt='Company Logo'
                        sx={{
                            width: '226px',
                            height: '195px',
                            objectFit: 'contain',
                        }}
                    />

                    <Typography
                        variant='h6'
                        fontWeight={600}
                        color='#132F5F'
                        sx={{
                            fontSize: '22px',
                            lineHeight: '28px',
                            fontFamily: 'Poppins, sans-serif',
                        }}
                    >
                        Welcome to Gensize
                        <br />
                        Indigent Management System
                    </Typography>

                    <Typography
                        variant='body2'
                        color='#919190'
                        sx={{
                            maxWidth: 500,
                            fontSize: '14px',
                            fontWeight: 500,
                            fontFamily: 'Poppins, sans-serif',
                        }}
                    >
                        This platform is designed to help you manage, review, and process
                        applications for indigent support with accuracy and efficiency.
                    </Typography>
                </Stack>
            </Paper>
        </Box>
    );
};

export default IndigentDashboard;
